import {
  Box,
  NumberDecrementStepper,
  NumberIncrementStepper,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
} from '@chakra-ui/react'
import { PropsWithChildren } from 'react'
import { filteredEvents } from '../../utils/events'
import { Container } from '../Container'

export const ToggleButton = ({
  active,
  onClick,
  disabled,
  children,
}: PropsWithChildren<{
  active: boolean
  onClick: () => void
  disabled?: boolean
}>) => (
  <Container
    {...(disabled ? {} : filteredEvents(onClick))}
    style={{
      cursor: disabled ? 'not-allowed' : 'pointer',
      flex: 1,
      height: '100%',
      fontSize: '12px',
      padding: '0 10px',
      background: active && !disabled ? '#ababab' : 'white',
      color: active && !disabled ? 'white' : '#ababab',
      opacity: disabled ? 0.4 : 1,
    }}>
    {children}
  </Container>
)

export const ToggleContainer = ({ children }: PropsWithChildren) => (
  <Container
    style={{
      height: 25,
      margin: 5,
      flexFlow: 'row',
      width: 'auto',
      border: '1px solid #ababab',
    }}>
    {children}
  </Container>
)

export const StyleToggle: React.FC<{
  active: boolean
  toggle: (value: boolean) => void
  label: string
  disabled?: boolean
}> = ({ active, toggle, label, disabled }) => (
  <ToggleContainer>
    <ToggleButton onClick={() => toggle(!active)} active={active} disabled={disabled}>
      {label}
    </ToggleButton>
  </ToggleContainer>
)

export const FontSizeSelect: React.FC<{
  fontSize?: number
  setFontSize: (size: number) => void
  step?: number
}> = ({ fontSize = 1, setFontSize, step = 0.2 }) => (
  <Box pl={1}>
    <NumberInput
      value={fontSize}
      {...filteredEvents()}
      onChange={(_, n) => setFontSize(n)}
      focusInputOnChange={false}
      size="xs"
      maxW={16}
      step={step}>
      <NumberInputField {...filteredEvents()} />
      <NumberInputStepper>
        <NumberIncrementStepper {...filteredEvents()} />
        <NumberDecrementStepper {...filteredEvents()} />
      </NumberInputStepper>
    </NumberInput>
  </Box>
)
